import BaseModel from '../BaseModel';
import { logType } from '../../../enums';

export default class OfficeInterviewLog extends BaseModel {
  static entity = 'interviewLogs';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      interviewId: this.attr(null),
      comment: this.string(null).nullable(),
      questionId: this.number(null).nullable(),
      questionType: this.string(null).nullable(),
      createdAt: this.string(null).nullable(),
      type: this.string(logType.ONLINE_INTERVIEW),
      eventType: this.string(logType.ONLINE_INTERVIEW),
    };
  }

  static apiConfig = {
    actions: {
      store(interviewId, payload) {
        return this.post(`interviews/${interviewId}/logs`, payload);
      },
      destroy(interviewLogId) {
        return this.delete(
          `interviews/logs/${interviewLogId}`,
          { delete: interviewLogId },
        );
      },
    },
  }
}
